import { LoadingOutlined } from '@ant-design/icons'
import { Spin } from 'antd'

const Loading = () => (
  // ใช้พื้นหลัง Gradient สีฟ้าของ JWC14 เหมือนหน้า Login เพื่อไม่ให้เกิดอาการจอกระพริบขาวเวลาโหลด
  <section className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden bg-[#398DF4] bg-[linear-gradient(140deg,#4AE3E9_0%,#398DF4_44%,#398DF4_100%)] font-inter antialiased">

    {/* ใส่เมฆลอยไว้ที่ขอบล่างเพื่อให้ดูเป็น CI เดียวกัน */}
    <img
      src="/J14/Asset/Cloud.svg"
      alt=""
      aria-hidden
      className="w-[54%] absolute bottom-0 left-0 opacity-100 z-10 pointer-events-none"
    />
    <img
      src="/J14/Asset/Cloud.svg"
      alt=""
      aria-hidden
      className="w-[56%] absolute bottom-0 right-0 opacity-100 -scale-x-100 z-10 pointer-events-none"
    />

    {/* ตัวหมุน Loading และข้อความ */}
    <div className="relative z-30 flex flex-col items-center justify-center">
      <Spin
        indicator={
          <LoadingOutlined
            style={{ fontSize: 100, color: '#ffffff' }} // เปลี่ยนสีเป็นสีขาวให้ตัดกับท้องฟ้า
            spin={true}
          />
        }
      />
      {/* เพิ่ม animate-pulse เพื่อให้ข้อความค่อย ๆ สว่างและมืดลงเบา ๆ ให้ความรู้สึกว่ากำลังประมวลผลอยู่ */}
      <h1 className="mt-8 text-2xl md:text-3xl font-bold text-white tracking-wider font-thai-looped drop-shadow-md animate-pulse">
        โปรดรอสักครู่...
      </h1>
    </div>
  </section>
)

export default Loading
